import React, { useState, useEffect } from "react";
import { postTransporte as addTransporte } from "../helpers/rutaTransportes";
import { getLocalidades } from "../helpers/rutaLocalidades";
import "../css/addclienteform.css";
import { Modal, Button } from "react-bootstrap";
import 'animate.css';


const AddTransporteForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    transporte: "",
    domicilio: "",
    telefono: "",
    cuit: "",
    email: "",
    localidad: "",
  });

  const [localidades, setLocalidades] = useState({
    data: { localidades: [] },
    loading: true,
  });

  useEffect(() => {
    getLocalidades().then((res) => {
      console.log("📦 Localidades cargadas:", res);
      if (res.ok && Array.isArray(res.localidades)) {
        setLocalidades({
          data: { localidades: res.localidades },
          loading: false,
        });
      } else {
        console.error("❌ Error al obtener localidades:", res.error);
        setLocalidades({
          data: { localidades: [] },
          loading: false,
        });
      }
    });
  }, []);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("🚚 Enviando transporte:", formValues);
      const resp = await addTransporte(formValues);
      console.log("✅ Transporte creado:", resp);

      setShowSuccess(true); // Mostrar modal de éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultarlo

        setFormValues({
          transporte: "",
          domicilio: "",
          telefono: "",
          cuit: "",
          email: "",
          localidad: "",
        });

        setShow(false); // Cerrar modal principal
      }, 2000);
    } catch (error) {
      console.error("❌ Error al crear transporte:", error);
      // Modal de error opcional
    }
  };

  

  return (
    <>
      {!localidades.loading && (
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              {/* Transporte */}
              <div className="form-group col-sm-2 mt-3">
                <label>Transporte</label>
                <input
                  type="text"
                  className="form-control"
                  name="transporte"
                  required
                  value={formValues.transporte}
                  onChange={handleChange}
                />
              </div>

              {/* Domicilio */}
              <div className="form-group col-sm-3 mt-3">
                <label>Domicilio</label>
                <input
                  type="text"
                  className="form-control"
                  name="domicilio"
                  required
                  value={formValues.domicilio}
                  onChange={handleChange}
                />
              </div>

              {/* Telefono */}
              <div className="form-group col-sm-2 mt-3">
                <label>Teléfono</label>
                <input
                  type="text"
                  className="form-control"
                  name="telefono"
                  required
                  value={formValues.telefono}
                  onChange={handleChange}
                />
              </div>

              {/* CUIT */}
              <div className="form-group col-sm-2 mt-3">
                <label>CUIT</label>
                <input
                  type="text"
                  className="form-control"
                  name="cuit"
                  required
                  value={formValues.cuit}
                  onChange={handleChange}
                />
              </div>

              {/* Email */}
              <div className="form-group col-sm-3 mt-3">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  required
                  value={formValues.email}
                  onChange={handleChange}
                />
              </div>

              {/* Localidad */}
              <div className="form-group col-sm-2 mt-3">
                <label>Localidad</label>
                <select
                  className="form-control"
                  name="localidad"
                  value={formValues.localidad}
                  onChange={handleChange}
                  required
                >
                  <option value="">Elija opción</option>
                  {localidades.data.localidades.map((loc) => (
                    <option key={loc._id} value={loc._id}>
                      {loc.localidad}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <button type="submit" className="btn btn-dark mt-4 mb-3">
              Guardar
            </button>
          </form>
        </div>
      )}

        <Modal
          show={showSuccess}
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="animate__animated animate__fadeInDown"
        >
          <Modal.Body className="text-center">
            <div style={{ fontSize: "3rem" }}>🖐</div>
            <h5 className="mt-2">¡Registro generado correctamente!</h5>
            </Modal.Body>
        </Modal>

    </>
  );
};

export default AddTransporteForm;
